import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5d80412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the-spotlight" }
const _hoisted_2 = { class: "the-spotlight-heading title is-sr-only" }
const _hoisted_3 = { class: "the-spotlight-item-filter" }
const _hoisted_4 = { class: "the-spotlight-item-filter-collection level-center is-mobile" }
const _hoisted_5 = { class: "the-spotlight-item-filter-collection-item" }
const _hoisted_6 = { class: "the-spotlight-body level" }
const _hoisted_7 = { class: "the-spotlight-item-list-wrapper" }
const _hoisted_8 = {
  ref: "scrollTarget",
  class: "the-spotlight-item-list",
  role: "article"
}
const _hoisted_9 = { class: "the-spotlight-nav is-hidden-mobile" }
const _hoisted_10 = { "aria-hidden": "true" }
const _hoisted_11 = {
  class: "the-spotlight-scroll-index has-text-thin level-center is-hidden-mobile",
  "data-cy": "the-spotlight-scroll-index"
}
const _hoisted_12 = { class: "the-spotlight-scroll-index has-text-thin level-center is-mobile is-hidden-desktop" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "4",
    r: "4"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppTag = _resolveComponent("AppTag")!
  const _component_ItemCardView = _resolveComponent("ItemCardView")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('label.spotlight')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_AppTag, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFilter('all'))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.onFilter('all')), ["prevent"]), ["space","enter"])),
            styled: _ctx.state.filtered === 'all' ? 'is-accent' : 'is-normal',
            text: _ctx.isRekion ? _ctx.$t('label.allSpotlightRekion') : _ctx.$t('label.allSpotlight'),
            tabindex: "0",
            role: "button"
          }, null, 8, ["styled", "text"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spotlightCategoryTags, (tag) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "the-spotlight-item-filter-collection-item",
            key: `spotlight-${tag.id}`
          }, [
            _createVNode(_component_AppTag, {
              onClick: ($event: any) => (_ctx.onFilter(tag.id)),
              onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.onFilter(tag.id)), ["prevent"]), ["space","enter"]),
              styled: _ctx.state.filtered === tag.id ? 'is-accent' : 'is-normal',
              text: _ctx.getCategoryLabel(tag),
              tabindex: "0",
              role: "button"
            }, null, 8, ["onClick", "onKeydown", "styled", "text"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spotlightItems, (spotlightItem, i) => {
            return (_openBlock(), _createBlock(_component_ItemCardView, {
              key: `spotlightItems-${i}-${spotlightItem.item.pid}`,
              context: spotlightItem.context,
              item: spotlightItem.item,
              label: spotlightItem.label,
              title: spotlightItem.title,
              thumbnail: spotlightItem.thumbnail,
              link: spotlightItem.link,
              class: _normalizeClass([{ 'is-hidden-mobile': i >= 9}, "the-spotlight-item has-background-contents shadow"]),
              tag: "article"
            }, null, 8, ["context", "item", "label", "title", "thumbnail", "link", "class"]))
          }), 128))
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ButtonIcon, {
          ref: "prevButton",
          icon: "pagination-prev",
          styled: "is-none",
          class: "the-spotlight-nav-prev has-text-modest shadow level-center",
          "aria-hidden": "true",
          tabindex: "-1"
        }, null, 512),
        _createVNode(_component_ButtonIcon, {
          ref: "nextButton",
          icon: "pagination-next",
          styled: "is-none",
          class: "the-spotlight-nav-next has-text-modest shadow level-center",
          "aria-hidden": "true",
          tabindex: "-1"
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexSize, (n) => {
          return (_openBlock(), _createElementBlock("li", {
            key: n,
            class: _normalizeClass({ 'has-text-modest': _ctx.currentIndex === n}),
            "data-cy": "the-spotlight-scroll-index-child"
          }, "●", 2))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spotlightItems.length, (n) => {
          return (_openBlock(), _createElementBlock("li", {
            key: n,
            class: _normalizeClass({ 'has-text-modest': _ctx.state.currentPosition === n })
          }, _hoisted_14, 2))
        }), 128))
      ])
    ])
  ]))
}